'use client';
import { SDKResponse } from '@commercetools/frontend-sdk';
import { PageResponse } from '@commercetools/frontend-sdk/lib/types/api/page';
import Toaster from 'components/commercetools-ui/atoms/toaster';
import MiniCartProvider from 'context/miniCart';
import TracingProvider from './tracing';

interface ProvidersProps {
  page: SDKResponse<PageResponse>;
}

export const Providers = ({ page, children }: React.PropsWithChildren<ProvidersProps>) => {
  return (
    <TracingProvider page={page}>
      <MiniCartProvider>{children}</MiniCartProvider>
      <Toaster />
    </TracingProvider>
  );
};
